// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3oWx2","log":"ModalInventoryLogs_log__28jpH","date":"ModalInventoryLogs_date__2n1N8","userName":"ModalInventoryLogs_userName__Ho4n3"};